var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 6.66667L3.33333 33.3333L36.6667 33.3333L36.6667 11.6667L31.6667 6.66667L3.33333 6.66667ZM35 31.6667L35 12.5L30.8333 8.33333L4.99999 8.33333L4.99999 31.6667L35 31.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 11.6667L28.3333 11.6667L28.3333 15L31.6667 15L31.6667 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6667L21.6667 11.6667L21.6667 15L25 15L25 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667L18.3333 11.6667L18.3333 15L15 15L15 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 11.6667L8.33333 11.6667L8.33333 15L11.6667 15L11.6667 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3333L8.33333 18.3333L8.33333 21.6667L11.6667 21.6667L11.6667 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3333L18.3333 18.3333L18.3333 21.6667L15 21.6667L15 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3333L21.6667 18.3333L21.6667 21.6667L25 21.6667L25 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 18.3333L31.6667 18.3333L31.6667 21.6667L28.3333 21.6667L28.3333 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 25L31.6667 25L31.6667 28.3333L28.3333 28.3333L28.3333 25Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25L21.6667 25L21.6667 28.3333L25 28.3333L25 25Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 25L18.3333 28.3333L15 28.3333L15 25L18.3333 25Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 28.3333L11.6667 25L8.33333 25L8.33333 28.3333L11.6667 28.3333Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 40 3.8147e-06)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.de3a1bcd1364bd5b28074c3bd6e09e1c.svg";
export { ForwardRef as ReactComponent };